import React from 'react';
import { TableFooterProps } from '../../../types/DesignSystem/Table';
import { withClassName } from '../cn';

const TableFooter: React.FC<TableFooterProps> = ({
  children,
  className = '',
}) => {
  const footerBase =
    'tw-bg-surface-sunken tw-border-t tw-border-edge tw-px-3 tw-py-2 tw-text-body-primary tw-text-ink';

  return (
    <tfoot>
      <tr>
        <td colSpan={100} className={withClassName(`${footerBase}`, className)}>
          {children}
        </td>
      </tr>
    </tfoot>
  );
};

export default TableFooter;
